// Port of api/fuel/app/classes/filter/search/games/filters/query/play/nolocation.php
export default {
	name: 'play.nolocation',
	priority: 64,
	require: function(config, filter) { return filter.play && filter.play.nolocation },
	run: function(config, filter, data, query) {
		query.where('p.play_location', '=', '')
	}
}
